import React, { useState, useEffect } from 'react';
import HeaderMobile from './HeaderMobile';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from './Constants';
import visionImg from './vision-mission.png';
import diagnosticImg from './About_Image2.jpg'; // Add your image here
import './Aboutus.css';
import PublicHeader from './PublicHeader';
const Contactus = () => {
      const [user, setUser] = useState(null);
      const [error, setError] = useState(null);
      const [loading, setLoading] = useState(true);
      const [isSidebarOpen, setIsSidebarOpen] = useState(false);
      const navigate = useNavigate();
    //    useEffect(() => {
    //       const token = localStorage.getItem('authToken');
    //       (async () => {
    //         try {
    //           const res = await fetch(`${BASE_URL}profile`, {
    //             headers: { Authorization: `Bearer ${token}` },
    //           });
    //           const data = await res.json();
    //           setUser(data.profile?.is_admin);
    //         } catch (err) {
    //           setError(err.message);
    //         } finally {
    //           setLoading(false);
    //         }
    //       })();
    //     }, []);
      
        const handleToggleSidebar = () => {
          if (window.innerWidth >= 992) setIsSidebarOpen(v => !v);
        };
  return (
      <div className="page-wrapper">
         <PublicHeader />
      {/* <HeaderMobile />
      <Sidebar isOpen={isSidebarOpen} /> */}
      <div className="page-container">
        {/* <Header onToggleSidebar={handleToggleSidebar} isSidebarOpen={isSidebarOpen} /> */}
    <div style={{ maxWidth: '960px', margin: '0 auto', padding: '100px 20px', fontFamily: 'Arial, sans-serif', lineHeight: '1.6', color: '#000' }}>
      <h2 style={{ color: '#0097a7', textAlign: 'center', marginBottom: '30px' }}>
   Registered Office  </h2>
     <h2 style={{ color: '#0097a7', textAlign: 'center', marginBottom: '30px' }}>
   Vijaya Diagnostic Centre Limited<br/>
   Address
   </h2>

      <p style={{ textAlign: 'justify' }}>
      Ground Floor, FPAI Building, Punjagutta Officers Colony, Near Topaz Building, Hyderabad, Telangana 500082
         </p>
          <p style={{ textAlign: 'justify' }}>
      Email : info@vijayadiagnostic.com    </p>
      <p style={{ textAlign: 'justify' }}>
      Customer Care No : 9240 222 222    </p>

      
    

</div>


        <Footer />
      </div>
    </div>
  
  );
};

export default Contactus;
